var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRentals({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.60709 1.80777C9.85045 1.66869 10.1493 1.66869 10.3926 1.80777L17.7109 5.98964C17.9769 6.1416 17.9769 6.52504 17.7109 6.677L10.3926 10.8589C10.1493 10.998 9.85045 10.998 9.60709 10.8589L2.2888 6.677C2.02287 6.52504 2.02287 6.1416 2.2888 5.98964L9.60709 1.80777Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22904 9.5L2.2888 12.323C2.02287 12.475 2.02287 12.8584 2.2888 13.0104L9.60709 17.1922C9.85045 17.3313 10.1493 17.3313 10.3926 17.1922L17.7109 13.0104C17.9769 12.8584 17.9769 12.475 17.7109 12.323L12.7707 9.5L10.3926 10.8589C10.1493 10.998 9.85045 10.998 9.60709 10.8589L7.22904 9.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRentals);
export default __webpack_public_path__ + "static/media/rentals.074cc139609005f793f2b44772e8b74c.svg";
export { ForwardRef as ReactComponent };